module.exports = __webpack_public_path__ + "static/img/head-pic-01.578986e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/head-pic-01.png
// module id = M3LB
// module chunks = 1